import React from 'react';
import PrivacyOption from './PrivacyOption';
import '../../pages/SurveyStart.scss';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function SurveyPrivacy({ privacy, onPrivacyChange, onStartSurvey, id, setCurrentPage, isLoading }) {
    const navigate = useNavigate();
    const language = localStorage.getItem('language') || 'Italian';

    const surveyQuestions = useSelector((state) => state?.attemptSurveyInfo?.surveyQuestions);
    const anonymity = surveyQuestions?.data?.setting[0]?.anonymity;

    const texts = {
        Italian: {
            selectOptionError: "Seleziona un'opzione",
            managePrivacy: "Gestisci la Privacy per questo Sondaggio",
            publicUser: "Utente Pubblico",
            publicDescription: "L'organizzatore sarà in grado di collegare la tua risposta con il tuo account. Potrai vedere quali altri utenti pubblici hanno dato le tue stesse risposte, e viceversa. Potrai ricevere premi se previsti.",
            privateUser: "Utente Privato",
            privateDescription: "Solo l'organizzatore sarà in grado di collegare le tue risposte con il tuo account. Non potrai vedere se altri utenti hanno dato le tue stesse risposte. Non potrai ricevere premi se previsti.",
            anonymousUser: "Utente Anonimo",
            anonymousDescription: "Nessuno (nemmeno l'organizzatore) sarà in grado di collegare le tue risposte con il tuo account. Non potrai vedere se altri utenti hanno dato le tue stesse risposte. Non potrai ricevere premi se previsti.",
            loading: "Caricamento...",
            participate: "Partecipa",
            cancel: "Annulla",
            publicWarning: "Puoi partecipare come Utente Pubblico solo tramite l'app Votiamo. Solo con l'app puoi vedere e chattare con gli altri partecipanti che hanno risposto come te ai sondaggi, e vincere i premi in palio."
        },
        English: {
            selectOptionError: "Please select an option",
            managePrivacy: "Manage Privacy for this Survey",
            publicUser: "Public User",
            publicDescription: "The organizer will be able to link your response with your account. You will be able to see which other public users have given the same answers as you, and vice versa. You may receive rewards if applicable.",
            privateUser: "Private User",
            privateDescription: "Only the organizer will be able to link your responses with your account. You will not be able to see if other users have given the same answers as you. You will not receive rewards if applicable.",
            anonymousUser: "Anonymous User",
            anonymousDescription: "No one (not even the organizer) will be able to link your responses with your account. You will not be able to see if other users have given the same answers as you. You will not receive rewards if applicable.",
            loading: "Loading...",
            participate: "Participate",
            cancel: "Cancel",
            publicWarning: "You can participate as a Public User only through the Votiamo app. Only with the app you can see and chat with other participants who answered like you to surveys, and win available prizes."
        }
    };

    const handleStartSurvey = (e) => {
        e.preventDefault();
        if (!privacy) {
            toast.error(language === 'Italian' ? texts[language].selectOptionError : texts[language].selectOptionError);
            return;
        }
        onStartSurvey();
    };

    const handlePrivacyChange = (e) => {
        const { id } = e.target;
        if (id === 'public') {
            toast.info(language === 'Italian' ? texts[language].publicWarning : texts[language].publicWarning);
            e.preventDefault(); // Prevent the change
        } else {
            onPrivacyChange(e);
        }
    };

    const handleCancel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setCurrentPage(0);
    };

    return (
        <div>
            <div className="title">
                <button>{language === 'Italian' ? texts[language].managePrivacy : texts[language].managePrivacy}</button>
            </div>
            <div className="privacy_wrapper">
                <div style={{ opacity: 0.4 }}>
                    <PrivacyOption
                        id="public"
                        label={language === 'Italian' ? texts[language].publicUser : texts[language].publicUser}
                        description={language === 'Italian' ? texts[language].publicDescription : texts[language].publicDescription}
                        checked={privacy === 'public'}
                        onChange={handlePrivacyChange}
                    />
                </div>
                <PrivacyOption
                    id="private"
                    label={language === 'Italian' ? texts[language].privateUser : texts[language].privateUser}
                    description={language === 'Italian' ? texts[language].privateDescription : texts[language].privateDescription}
                    checked={privacy === 'private'}
                    onChange={handlePrivacyChange}
                />
                {
                    anonymity && (
                        <PrivacyOption
                            id="anonymous"
                            label={language === 'Italian' ? texts[language].anonymousUser : texts[language].anonymousUser}
                            description={language === 'Italian' ? texts[language].anonymousDescription : texts[language].anonymousDescription}
                            checked={privacy === 'anonymous'}
                            onChange={handlePrivacyChange}
                        />
                    )
                }
            </div>
            <div className="action">
                <button onClick={handleStartSurvey} disabled={isLoading}>
                    {isLoading ? (language === 'Italian' ? texts[language].loading : texts[language].loading) : (language === 'Italian' ? texts[language].participate : texts[language].participate)}
                </button>
                <button
                    type="button"
                    className="cancel"
                    onClick={handleCancel}
                    style={{ cursor: 'pointer' }}
                >
                    {language === 'Italian' ? texts[language].cancel : texts[language].cancel}
                </button>
            </div>
        </div>
    );
}
